<script lang="ts" setup>
import { ref } from 'vue'
import Draggable from 'vuedraggable'

import { CompanyProduct } from '@/types/packaging'

import ProductItem from '@/components/packaging/products/ProductItem.vue'

interface Props {
    simpleProductCard?: boolean
    currency?: string
}

const products = defineModel<CompanyProduct[]>()
const props = defineProps<Props>()
const emit = defineEmits<{
    (e: 'order-updated'): void
    (e: 'favorite-clicked', product: CompanyProduct): void
}>()

const dragging = ref(false)

function orderUpdated() {
    dragging.value = false
    emit('order-updated')
}
</script>

<template>
    <Draggable
        v-model="products"
        :class="{ 'dragging cursor-grabbing': dragging }"
        ghost-class="drag-ghost-card"
        handle=".handle"
        class="mb-14 mt-5 grid gap-6"
        item-key="id"
        @end="orderUpdated"
        @start="dragging = true"
    >
        <template #item="{ element }">
            <ProductItem
                :dragging="dragging"
                :product="element"
                favored
                show-favorite-icon
                :simple-product-card="props.simpleProductCard"
                :currency="props.currency"
                @favorite-clicked="emit('favorite-clicked', element)"
            />
        </template>
    </Draggable>
</template>
